export default __webpack_public_path__ + "static/media/eye-open.be1b0a96.svg";